import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./loadingBlock.style.css";
export const LoadingBlock = ({ className }) => {
    return (_jsx("div", { className: `loading-block w-12 h-12  ${className}`, children: _jsxs("div", { className: `grid bg-transparent grid-cols-2 gap-1 w-full h-full`, children: [_jsx("div", { className: "bg-red-400" }), _jsx("div", { className: "bg-green-400" }), _jsx("div", { className: "bg-orange-500" }), _jsx("div", { className: "bg-blue-400" })] }) }));
};
